var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container fluid mt-3"},[_c('h1',{staticClass:"display-2 grey--text"},[_vm._v("Offices Page")]),_c('div',{staticClass:"grid-x grid-margin-y"},[_c('div',{staticClass:"cell small-12 mt-5"},[_c('v-card',[_c('v-card-text',[(_vm.offices.length > 0)?_c('OfficesTable',{attrs:{"offices":_vm.offices}}):_vm._e()],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }